import { proxyCustomElement, HTMLElement } from '@stencil/core/internal/client';
import { f as formatBytes } from './number.js';

const FormatBytes = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.value = 0;
    this.unit = 'bytes';
    this.locale = undefined;
  }
  render() {
    return formatBytes(this.value, {
      unit: this.unit,
      locale: this.locale,
    });
  }
}, [1, "sl-format-bytes", {
    "value": [2],
    "unit": [1],
    "locale": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["sl-format-bytes"];
  components.forEach(tagName => { switch (tagName) {
    case "sl-format-bytes":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, FormatBytes);
      }
      break;
  } });
}

const SlFormatBytes = FormatBytes;
const defineCustomElement = defineCustomElement$1;

export { SlFormatBytes, defineCustomElement };
